import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import VueRouter from 'vue-router';
import iView from 'iview';
import 'iview/dist/styles/iview.css';
import '@/assets/css/common.css';
import axios from 'axios';
import *as moment from 'moment';
import { Base64 } from 'js-base64';

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

Vue.config.productionTip = false;

// let myrequest =axios.create({
// 	baseURL:'https://facecloud.panxsoft.com'
// })


Vue.prototype.$moment = moment
Vue.prototype.axios = axios
Vue.prototype.$base64 = Base64

Vue.use(ElementUI);
Vue.use(VueRouter);
Vue.use(iView);

new Vue({
  el: '#app',
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
